import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { TableOfContents } from '../../TableOfContents/TableOfContents';
import { StyledArticleTableOfContents } from '../ContentBlogArticlePage.styles';

type Props = {
    links: {
        name: string;
        href: string;
        id: string;
    }[];
    $target: 'desktop' | 'mobile';
};

export const ArticleTableOfContents: FC<Props> = ({ links, $target }) => {
    const { t } = useTranslations();

    if (links.length > 0) {
        return (
            <StyledArticleTableOfContents $target={$target}>
                <TableOfContents
                    links={links}
                    headingTitle={t['blog.article_page.table_of_contents.heading']}
                    headingTag="h2"
                />
            </StyledArticleTableOfContents>
        );
    }

    return null;
};
